import React from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import { Box } from '@mui/material';
import { CardGridPropTypes } from './CardGrid.propTypes';

/**
 * A responsive grid container that arranges children into a grid layout.
 * Uses Material-UI's Grid2 component for layout, allowing
 * customization of spacing and width.
 *
 *
 * @param {object} props - The props object.
 * @param {React.ReactNode} props.children - The children components to render inside the grid.
 * @param {number} [columnSpacing = 2, rowSpacing = 2] - The spacing between grid items (default is 2).
 * @param {string} [props.width] - The width of the grid container (e.g., '100%', 'auto').
 *
 * @returns {JSX.Element} A Material-UI grid container that renders children in a flexible layout.
 */
function CardGrid({ children, columnSpacing = 2, rowSpacing = 2, maxWidth }) {
  return (
    <Box>
      <Grid container columnSpacing={columnSpacing} rowSpacing={rowSpacing} sx={{ display: 'flex', justifyContent: 'space-between', margin:'0px' }} >
        {React.Children.map(children, child => (
          <Grid
            xs={12}
            md={'auto'}
            key={child}
            sx={{
              maxWidth: maxWidth ? `${maxWidth} !important` : 'none',
            }}
          >
            {child}
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

CardGrid.propTypes = CardGridPropTypes;

export default CardGrid;
